import { useAtomValue, useSetAtom } from "jotai";
import { useNavigate } from "react-router-dom";
import { motion, useReducedMotion } from "motion/react";
import { Icon } from "@iconify/react";
import { activeSectionAtom, menuOpenAtom } from "@/atoms/layout.atoms";
import { navSections } from "../layout/header";
import { cinematicEase } from "../ui/reveal-text";
import SocialMedia from "../ui/social-media";

export default function Menu() {
  const setMenuOpen = useSetAtom(menuOpenAtom);
  const activeSection = useAtomValue(activeSectionAtom);
  const navigate = useNavigate();
  const reduceMotion = useReducedMotion();

  const handleSectionClick = (section: string) => {
    navigate(section === "home" ? "/" : `/${section}`);
    setMenuOpen(false);
  };

  return (
    <div className="flex h-full w-full max-w-86 flex-col pb-8 pt-5">
      <nav
        aria-label="Mobile navigation"
        className="my-auto flex w-full flex-col"
      >
        {navSections.map((section, index) => {
          const isActive = activeSection === section.id;

          return (
            <motion.button
              key={section.id}
              type="button"
              onClick={() => handleSectionClick(section.id)}
              aria-current={isActive ? "page" : undefined}
              initial={reduceMotion ? false : { opacity: 0, y: 28 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{
                duration: 0.6,
                delay: 0.12 + index * 0.06,
                ease: cinematicEase,
              }}
              className="group flex items-baseline gap-4 border-b border-white/10 py-5 text-left"
            >
              <span className="w-6 font-mono text-[11px] text-white/40">
                {String(index + 1).padStart(2, "0")}
              </span>
              <span
                className={`flex-1 text-[1.9rem] font-light leading-none tracking-[-0.03em] transition-colors ${
                  isActive ? "text-white" : "text-white/60"
                }`}
              >
                {section.label}
              </span>
              <Icon
                icon="material-symbols:arrow-outward"
                className={`text-xl transition-colors ${
                  isActive ? "text-[#DEFF77]" : "text-white/30"
                }`}
              />
            </motion.button>
          );
        })}
      </nav>
      <motion.div
        initial={reduceMotion ? false : { opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.6, delay: 0.45 }}
        className="flex w-full flex-col items-center gap-3"
      >
        <SocialMedia />
        <span className="text-xs text-white/50">
          © 2026 Elevintia. All Rights Reserved.
        </span>
      </motion.div>
    </div>
  );
}
